import { defineStore } from 'pinia';
import type { ErrorInfo } from "@/types/ErrorModel";

export const useErrorStore = defineStore('error', {
  state: () => ({
    error: null as ErrorInfo | null
  }),

  getters: {
    getError: (state) => state.error
  },

  actions: {
    setError(error: ErrorInfo | null) {
      this.error = error;
    }
  }
}); 